/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Trans, useTranslation } from 'gatsby-plugin-react-i18next';

function ClarificationText() {
  const { t } = useTranslation('clarificationtext');

  return (
    <>
      <h1>{t('0.h1')}</h1>
      <p>
        <Trans
          t={t}
          i18nKey="0.p"
          components={{ bold: <b /> }}
        />
      </p>
      <h2>{t('1.h2')}</h2>
      <p>{t('1.p1')}</p>
      <p>
        <Trans
          t={t}
          i18nKey="1.p2"
          components={{ bold: <b /> }}
        />
      </p>
      <p>{t('1.p3')}</p>
      <p>{t('1.p4')}</p>
      <ul className="bullet">
        {t('1.p4li', { returnObjects: true }).map((p, i) => (
          <li key={i}>
            {p}
          </li>
        ))}
      </ul>
      <p>{t('1.p5')}</p>
      <h2>{t('2.h2')}</h2>
      {t('2.p', { returnObjects: true }).map((p, i) => (
        <p key={i}>
          {p}
        </p>
      ))}
      <h2>{t('3.h2')}</h2>
      {t('3.p', { returnObjects: true }).map((p, i) => (
        <p key={i}>
          {p}
        </p>
      ))}
      <h2>{t('4.h2')}</h2>
      <p>{t('4.p1')}</p>
      <ul className="bullet">
        {t('4.p1li', { returnObjects: true }).map((p, i) => (
          <li key={i}>
            {p}
          </li>
        ))}
      </ul>
      <p>{t('4.p2')}</p>
      <p>{t('4.p3')}</p>
      <p>{t('4.p4')}</p>
      <h2>{t('5.h2')}</h2>
      {t('5.p', { returnObjects: true }).map((p, i) => (
        <p key={i}>
          {p}
        </p>
      ))}
      <h2>{t('6.h2')}</h2>
      <p>{t('6.p1')}</p>
      <ul className="bullet">
        {t('6.p1li', { returnObjects: true }).map((p, i) => (
          <li key={i}>
            {p}
          </li>
        ))}
      </ul>
      <p>{t('6.p2')}</p>
      <h2>{t('7.h2')}</h2>
      {t('7.p', { returnObjects: true }).map((p, i) => (
        <p key={i}>
          {p}
        </p>
      ))}
      <h2>{t('8.h2')}</h2>
      {t('8.p', { returnObjects: true }).map((p, i) => (
        <p key={i}>
          {p}
        </p>
      ))}
    </>
  );
}

export default ClarificationText;
